import { Component, OnInit, Input } from '@angular/core';

import { FormPackage } from '../../models/df-package';
import { FormGroup, Validators, AbstractControl, FormControl } from '@angular/forms';

@Component({
	selector: 'df-label',
	templateUrl: './label.component.html',
	styleUrls: ['./label.component.scss']
})
export class LabelComponent implements OnInit {
	@Input() package: FormPackage;
	@Input() form: FormGroup;
	@Input() config: FormGroup;

	constructor() {}

	// eslint-disable-next-line @angular-eslint/no-empty-lifecycle-method
	ngOnInit() {}
}
